<template>
  <IconLucideX />
</template>
